import { CommunicationCenterOptionsService, REDIRECT, EmailDetailsService } from '@/imports-files/pages/clients/communication/index';

export class CommunicationCenterOptionsActions
{
    constructor(router)
    {
        this.communicationCenterOptionsService = new CommunicationCenterOptionsService();
         this.emailDetailsService = new EmailDetailsService();
        this.router = router
    }

    performJobAction(ActionName, params)
    {
        switch(ActionName)
        {
            case 'mark_as_read':
                            this.markAsRead(params);
                            break;
            case 'mark_as_unread':
                            this.markAsUnread(params);
                            break;
            case 'dismiss':
                params.setConfirmationModal({ state: true, message: params.t('modal:confirmation:delete:email'), confirm_btn_action: () => { this.dismiss(params) } });
                            // this.dismiss(params);
                            break;
            default: '';
        }  
    }

    async markAsRead(args)
    {   
        var params = '';
        if(typeof args.id == 'object')
        {
            var id_arr = [];
            for (let element of args.id.selectedRows )
            {
                if(element.parent_id && element.child_ids)
                {
                    id_arr.push(element.parent_id)
                    id_arr = id_arr.concat(element.child_ids)
                }   
                else if(element.parent_id)
                {
                    id_arr.push(element.parent_id)
                    id_arr.push(element.id)
                }
                else
                {
                    id_arr.push(element.id)
                }
            }
            
            params = { ids: id_arr, read: true }
            params.ids =  [...new Set(params.ids)]
        }
        else
        {
            if(args.row.parent_id && args.row.child_ids)
            {
                params = { ids: [args.row.parent_id].concat(args.row.child_ids), read: true }
            }
            else if(args.row.parent_id)
            {
                 params = { ids: [args.row.parent_id].push(args.row.id), read: true }
            }
            else
            {
                params = { ids: args.row.id, read: true }
            }
        }

        params.email_type = this.router.query.email_type
        var result = await this.communicationCenterOptionsService.markAsRead(params);
        args.setApiError(result.request)
        args.setCommunicationBulkActionModal(false);
        args.setConfirmationModal({ state: false, message: '', confirm_btn_action: null });
        args.closeAllJobsOptions;
        this.deselectAllCandidates();
        if(args.redirect)
        {
            let link = REDIRECT.client.communication.emails.replace('$comm_detail_id', args.row.id)
            this.router.push({pathname:link, query: this.router.query})
         }
        else{
            args.setCommunicationList(result.data);
            args.setFlagForRerender(Math.random() * 10000);
        }
    }

    async markAsUnread(args)
    {
        var params = '';
        if(typeof args.id == 'object')
        {
            var id_arr = [];
            for (let element of args.id.selectedRows )
            {
                if(element.parent_id && element.child_ids)
                {
                    id_arr.push(element.parent_id)
                    id_arr = id_arr.concat(element.child_ids)
                }   
                else if(element.parent_id)
                {
                    id_arr.push(element.parent_id)
                    id_arr.push(element.id)
                }
                else
                {
                    id_arr.push(element.id)
                }
                
            }
            
            params = { ids: id_arr, read: false }
            params.ids =  [...new Set(params.ids)]
        }
        else
        {
            // params = { ids: [args.id], read: false }
            if(args.row.parent_id && args.row.child_ids)
            {
                params = { ids: [args.row.parent_id].concat(args.row.child_ids), read: false }
            }
            else if(args.row.parent_id)
            {
                params = { ids: [args.row.parent_id].push(args.row.id), read: false }
            }
            else
            {
                params = { ids: args.row.id, read: false }
            }
        }   
        params.email_type = this.router.query.email_type
        var result = await this.communicationCenterOptionsService.markAsRead(params);
        args.setApiError(result.request)
        args.setCommunicationList(result.data);
        args.setCommunicationBulkActionModal(false);
        args.setConfirmationModal({ state: false, message: '', confirm_btn_action: null });
        args.closeAllJobsOptions;
        args.setFlagForRerender(Math.random() * 10000);
        this.deselectAllCandidates();
    }

    async dismiss(args)
    {
        var params = '';
        if(typeof args.id == 'object')
        {   
            var id_arr = [];
            for (let element of args.id.selectedRows )
            {
                if(element.parent_id && element.child_ids)
                {
                    id_arr.push(element.parent_id)
                    id_arr = id_arr.concat(element.child_ids)
                }   
                else if(element.parent_id)
                {
                    id_arr.push(element.parent_id)
                    id_arr.push(element.id)
                }
                else
                {
                    id_arr.push(element.id)
                }
                
            }
            
            params = { ids: id_arr, read: true }
            params.ids =  [...new Set(params.ids)]

        }
        else
        {
            // params = { ids: [args.id], read: true }

            if(args.row.parent_id && args.row.child_ids)
            {
                params = { ids: [args.row.parent_id].concat(args.row.child_ids), read: true }
            }
            else if(args.row.parent_id)
            {
                 params = { ids: [args.row.parent_id].push(args.row.id), read: true }
            }
            else
            {
                params = { ids: args.row.id, read: true }
            }
        }

        params.email_type = this.router.query.email_type
        var result = await this.communicationCenterOptionsService.dismiss(params);
        args.setApiError(result.request)
        args.setCommunicationList(result.data);
        args.setCommunicationBulkActionModal(false);
        args.setConfirmationModal({ state: false, message: '', confirm_btn_action: null });
        args.closeAllJobsOptions;
        args.setFlagForRerender(Math.random() * 10000);
        this.deselectAllCandidates();
    }

    deselectAllCandidates()
    {
        var all_checkbox = document.querySelector('[name = select-all-rows]')
        if(all_checkbox)
        {
            if(all_checkbox?.checked)
            {
                all_checkbox.click();
            }
            else
            {
                all_checkbox.click();
                all_checkbox.click();
            }
        }
    }
    
    showCommunicationCenterOptions(data, key)
    {
        if(this.router.query.email_type == 'inbox')
        {
            if (data.read)
            {
                return key == 'mark_as_unread' || key == 'dismiss'
            }
            else
            {
                return key == 'mark_as_read' || key == 'dismiss'
            }
        }
        else
        {
            if(key == 'mark_as_unread' || key == 'mark_as_read')
            {
                return false;
            }
            else
            {
                return true;
            }
        }
    }

    async toggle(event, data, page_name)
    {
        let params = {};
        let result = '';
        event.stopPropagation();
        params['id'] = [data.id]
        
        let element_classes = event.currentTarget;
        if(element_classes.classList.contains('ImportantEmail'))
        {
            params['important'] = false;
            result = await this.emailDetailsService.markAsImportantAndUnimportant(params)
            if(result.status == 200)
            {
              element_classes.classList.remove('ImportantEmail');
              element_classes.classList.add('NotImportantEmail')
            }
        }
        else
        {
            params['important'] = true;
            result = await this.emailDetailsService.markAsImportantAndUnimportant(params)
            if(result.status == 200)
            {
              element_classes.classList.remove('NotImportantEmail');
              element_classes.classList.add('ImportantEmail')
            }
        }

       
    }
}